import { useState } from "react";
import * as v from "valibot";
import { valibotResolver } from "@hookform/resolvers/valibot";
import { Button, Col, Container, Form, Row } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { useAddCategoryMutation } from "../../../features/api/category/categoryApi";
import { Input } from "../../common/input/Input";
import { CustomToast } from "../../common/customToast/CustomToast";

const schema = v.object({
  name: v.pipe(
    v.string("Name is required"),
    v.minLength(3, "At least 3 letters is required")
  ),
});

export const AddCategory = ({ onSuccess }) => {
  const [category, setCategory] = useState({
    name: "",
  });
  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm({
    defaultValues: category,
    resolver: valibotResolver(schema),
  });
  const [addCategory, { isLoading, isSuccess, isError, error }] =
    useAddCategoryMutation();
  const onSubmit = async (data) => {
    try {
      await addCategory(data).unwrap();
      setTimeout(() => {
        onSuccess();
      }, 5000);
    } catch (err) {}
    // Perform API request to update product -
    reset();
  };

  return (
    <div className="mb-5">
      <Container className="mt-5 shadow-sm">
        {isSuccess && <CustomToast msg={"Category added successfully!"} />}
        {isError && <CustomToast err={error} msg={error.data.errorMessage} />}
        <Form onSubmit={handleSubmit(onSubmit)}>
          <Row>
            <Col xs={12}>
              <Input
                label={"Category name"}
                field={"name"}
                register={register}
                defaultValue={category.name}
                errors={errors}
              />
            </Col>
          </Row>
          <Row className="py-2">
            <Col lg={12}>
              <Button
                type="submit"
                variant="success"
                className="w-100"
                disabled={isLoading}
              >
                {isLoading ? "Saving" : "Submit"}
              </Button>
            </Col>
          </Row>
        </Form>
      </Container>
    </div>
  );
};
